import { render, staticRenderFns } from "./CardEvenement.vue?vue&type=template&id=24726367&lang=html&"
import script from "./CardEvenement.vue?vue&type=script&lang=js&"
export * from "./CardEvenement.vue?vue&type=script&lang=js&"
import style0 from "./CardEvenement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports